import {SearchModel, SearchResult, SearchSortField} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {Observable, of} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class MembershipTypeSearchModel extends SearchModel<any> {
    public static readonly GUEST_MEMBERSHIP_TYPE: number = -1;

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "membershipTypeId";
    }

    override searchRecords(filter: any, start: number, limit: number, sort: SearchSortField[]): Observable<SearchResult> {
        if (filter.membershipTypeId === MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE) {
            const translateService: TranslateService = this.injector.get(TranslateService, null)
            return of({
                totalCount: 1,
                countable: true,
                data: [{
                    membershipTypeId: MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE,
                    name: translateService.instant("wbo.membership-type.option.guest")
                }]
            });
        }
        return super.searchRecords(filter, start, limit, sort);
    }
}
